import ApplicationSerializer from 'cio/serializers/application';
import DS from 'ember-data';

const { EmbeddedRecordsMixin } = DS;

export default class TransactionalMessageSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    tags: { serialize: 'ids' },
  },
}) {}
